import { Controller } from 'stimulus';

import sortable from 'html5sortable/dist/html5sortable.es.js';

export default class extends Controller {
  static sortupdateEventListened = false;

  initialize() {
    this.root = this.data.get('root');

    this.initSortable();
  }

  initSortable() {
    sortable(this.element, {
      acceptFrom: '.office-catalog-categories__sortable',
      forcePlaceholderSize: true,
      handle: '.handle',
    });

    if (this.sortupdateEventListened) {
      return;
    }

    const controller = this;
    this.element.addEventListener('sortupdate', (e) => {
      controller.application.getControllerForElementAndIdentifier(e.detail.item, 'office--catalog--category').moveTo(
        controller.application.getControllerForElementAndIdentifier(e.detail.destination.container, 'office--catalog--categories').root,
        e.detail.destination.elementIndex
      );
    });
    this.sortupdateEventListened = true;
  }
}
